import { connect } from 'react-redux';

import Chart from 'components/chart/Chart';
import Grid from 'components/grid/Grid';
import { bindActionCreators, Dispatch } from 'redux';
import { metOceanAtTime } from 'services/metOcean';
import {
    SetErrorHandlerAction,
    setErrorHandlerAction,
    SetSystemLoadingAction,
    setSystemLoadingAction,
    ShowMessageAction,
    showMessageAction,
    ShowSystemErrorAction,
    showSystemErrorAction,
} from 'store/actions/errorsActions';
import {
    SetHighlightObjectAction,
    setHighlightObjectAction,
    SetLayoutAction,
    setLayoutAction,
    SetMainControlsAction,
    setMainControlsAction,
    SetOpendMenuAction,
    setOpendMenuAction,
    SetSearchObjectAction,
    setSearchObjectAction,
    setSwitchAction,
    SetSystemAction,
    setSystemAction,
} from 'store/actions/layoutActions';
import {
    SetDefaultDataAction,
    setDefaultDataAction,
    SetTagsAction,
    setTagsAction,
    SetVesselCategoriesAction,
    setVesselCategoriesAction,
} from 'store/actions/portActions';
import { SetPortAction, setPortAction, setPortIdAction, SetPortIdAction } from 'store/actions/userActions';
import {
    CloseModel,
    EnviroDisplayOrderType,
    EnviroDisplayType,
    Layout,
    OpenModal,
    PortType,
    PortURLType,
    RootState,
    SwitchType,
    TransitsDataType,
    TransitType,
    UserType,
} from 'types';
import {
    GetMetOceanDataInterface,
    GetVesselLastTransitInterface,
    MapControlsInterface,
    PlaybackTransitInterface,
    SearchControlsInterface,
    SearchVesselLastTransitInterface,
} from 'types/functions';
import { DefaultData, FilterObjectType } from 'types/search';
import { MetOceanData, SystemType } from 'types/system';
import { DateTimeFormat } from 'utils/dateTimeFormat';
import { checkDifferent, clone, getId, setKey } from 'utils/formHandlers';
import { filterBySection } from 'utils/layers';
import {
    formatFilterObject,
    formatMetOceanData,
    formatSavedFilter,
    formatTransits,
    getEnviroDisplayDataAvrages,
} from 'utils/migrations';

import { searchData } from 'services/search';
import { PortState } from 'store/reducers/portReducer';
import { PortManager } from 'utils/IndexedDB';
import { translate } from 'utils/translate';
import { withRouter } from 'utils/withRouter';
import { SETTINGS } from '../settings';
import MenuManager from './MenuManager';
import ModalManager from './ModalManager';
import { MainBase } from './baseClass/MainBase';
import Playback from './chart/Playback';
import Time from './chart/Time';
import KeyboardManager from './keyboardManager';
import Tabs from './main/Tabs';
import Toolbar from './main/Toolbar';
import User from './main/User';
import Comments from './managers/comments/Comments';
import Ports from './managers/ports/Ports';
import Searches from './managers/searches/Searches';
import Tags from './managers/tags/Tags';
import Users from './managers/users/Users';
import MetOcean from './metOcean/MetOcean';
import Profile from './profile/Profile';
import ApplicationError from './system/ApplicationError';
import ApplicationLoading from './system/ApplicationLoading';
import ForbiddenError from './system/ForbiddenError';
import MobileError from './system/MobileError';
import NetworkError from './system/NetworkError';
import ServerError from './system/ServerError';
import Chat from './chat/Chat';
export interface MainProps {
    port: PortType;
    user: UserType;
    layout: Layout;
    system: SystemType | null;
    defaultData: DefaultData;
    switchs: SwitchType;
    mapControls: MapControlsInterface;
    mode: string;
    portData: PortState;
    params: { [key: string]: any };
    outlineInterval: number;
    searchObject: FilterObjectType;
    setSwitchAction: (key: string, value: object) => void;
    setSearchObjectAction: SetSearchObjectAction;
    setHighlightObjectAction: SetHighlightObjectAction;
    setPortIdAction: SetPortIdAction;
    setLayoutAction: SetLayoutAction;
    setOpendMenuAction: SetOpendMenuAction;
    setSystemAction: SetSystemAction;
    setTagsAction: SetTagsAction;
    setPortAction: SetPortAction;
    setDefaultDataAction: SetDefaultDataAction;
    setVesselCategoriesAction: SetVesselCategoriesAction;
    setSystemLoadingAction: SetSystemLoadingAction;
    showSystemErrorAction: ShowSystemErrorAction;
    setErrorHandlerAction: SetErrorHandlerAction;
    setMainControlsAction: SetMainControlsAction;
    openModelFunction: OpenModal;
    closeModelFunction: CloseModel;
    dateTimeFormat: DateTimeFormat;
    showMessageAction: ShowMessageAction;
    searchControls: SearchControlsInterface;
}

export interface MainState {
    layout: Layout;
    loading: boolean;
    outlineInterval: number;
    selectedTransit: number | string | null;
    selectedTime: DateTimeFormat | null;
    system: SystemType | null;
    defaultData: DefaultData;
    transits: TransitType[];
    transitsData: TransitsDataType;
    savedData: any | null;
    switchs: SwitchType;
    systemUpdateCheck: {
        state: boolean;
        cancel: any;
    };
    userMenu: boolean;
    metOceanData: MetOceanData[];
    getingMetOceanData: {
        transitId: number;
        loading: boolean;
        time: null | DateTimeFormat;
    };
    environmentalSources: PortURLType[] | undefined;
    enviroDisplay: EnviroDisplayType | undefined;
    enviroDisplayOrder: EnviroDisplayOrderType[] | undefined;
}

class Main extends MainBase {
    constructor(props: MainProps) {
        super(props);
        this.state = {
            outlineInterval: props.outlineInterval,
            switchs: clone(props.switchs),
            layout: clone(props.layout),
            systemUpdateCheck: {
                state: true,
                // eslint-disable-next-line @typescript-eslint/no-empty-function
                cancel: () => {},
            },
            loading: true,
            system: props.system,
            defaultData: props.defaultData,
            selectedTransit: null,
            selectedTime: null,
            transits: [],
            transitsData: {},
            savedData: null,
            userMenu: false,
            getingMetOceanData: {
                transitId: 0,
                loading: false,
                time: null,
            },
            metOceanData: [],
            enviroDisplayOrder: props.port?.meta_data.enviroDisplayOrder,
            enviroDisplay: props.port?.meta_data.enviroDisplay,
            environmentalSources: props.port?.port_urls?.filter((x) => {
                return x.type === 'environmental';
            }),
        };
    }

    static getDerivedStateFromProps(props: MainProps, state: MainState) {
        if (
            checkDifferent(props.layout, state.layout) ||
            checkDifferent(props.outlineInterval, state.outlineInterval) ||
            checkDifferent(props.defaultData, state.defaultData) ||
            checkDifferent(props.switchs, state.switchs) ||
            checkDifferent(props.system, state.system)
        ) {
            return {
                dateTimeFormat: props.dateTimeFormat,
                outlineInterval: props.outlineInterval,
                system: props.system,
                switchs: clone(props.switchs),
                defaultData: props.defaultData,
                layout: props.layout,
                enviroDisplayOrder: props.port?.meta_data.enviroDisplayOrder,
                enviroDisplay: props.port?.meta_data.enviroDisplay,
                environmentalSources: props.port?.port_urls?.filter((x) => {
                    return x.type === 'environmental';
                }),
            };
        }

        return null;
    }

    playbackTransit: PlaybackTransitInterface = (id, selectedTime = null, tempraryTransit?: TransitType) => {
        if (!id) {
            window?.log('ERROR : Invalid transit data', 'colour: red');
            return;
        }
        const { transit } = tempraryTransit ? { transit: tempraryTransit } : this.getTransit(id);
        this.props.mapControls.playback?.hideTooltips();
        this.props.setLayoutAction([
            {
                action: 'DEFAULT',
                data: {
                    viewPort: this.props.mapControls.chart?.getViewPort(),
                    playbackSelectedTime: selectedTime,
                    tempraryTransit: transit || null,
                    playbackTransit: id,
                    playbackId: getId(),
                },
            },
            { action: 'UPDATE_DATA', data: { section: 'replay', data: { transit: transit } } },
            { action: 'UPDATE_DATA', data: { section: 'playback', data: { transit: transit } } },
            { action: 'UPDATE_MODE', data: { section: 'replay', mode: 'playback' } },
            { action: 'UPDATE_MODE', data: { section: 'playback', mode: 'playback' } },
            {
                action: 'UPDATE_SECTION',
                data: { name: 'replay', state: true, loading: true, display: true, disable: false },
            },
            {
                action: 'UPDATE_SECTION',
                data: { name: 'playback', state: true, loading: true, display: true, disable: false },
            },
            // {
            //     action: 'UPDATE_MENU',
            //     data: {
            //         name: 'inspectTransitMenu',
            //         section: 'chart',
            //         state: false,
            //         display: false,
            //     },
            // },
            // {
            //     action: 'UPDATE_MENU',
            //     data: {
            //         name: 'inspectTransitMenu',
            //         section: 'grid',
            //         state: false,
            //         display: false,
            //     },
            // },
            {
                action: 'UPDATE_MENU',
                data: {
                    name: 'playbackMenu',
                    section: 'playback',
                    state: true,
                },
            },
        ]);
        this.props.mapControls.playback?.setViewPort(
            //@ts-ignore
            this.props.layout.viewPort?.latitude,
            this.props.layout.viewPort?.longitude,
            this.props.layout.viewPort?.zoom
        );
    };

    async componentDidMount(): Promise<void> {
        this.props.setMainControlsAction({
            getOption: this.getOption,
            setTransits: this.setTransits,
            updateTransits: this.updateTransits,

            updateDrawTrack: this.updateDrawTrack,

            updateDisplay: this.updateDisplay,
            updateSelection: this.updateSelection,
            updateSelectionFromArray: this.updateSelectionFromArray,
            updatehighlight: this.updatehighlight,

            updateDrawSweptPath: this.updateDrawSweptPath,
            updateDrawVesselOutline: this.updateDrawVesselOutline,
            transitDownloadSweptPathFile: this.transitDownloadSweptPathFile,
            transitsExportFile: this.transitsExportFile,
            transitExportFile: this.transitExportFile,
            getBestPosition: this.getBestPosition,
            updateDisplayAll: this.updateDisplayAll,
            getDisplayedTransits: this.getDisplayedTransits,
            updateHighlightAll: this.updateHighlightAll,

            getSelectedTranist: this.getSelectedTranist,
            refreshTaglist: this.refreshTaglist,
            getMetOceanData: this.getMetOceanData,
            getVesselLastTransit: this.getVesselLastTransit,
            searchVesselLastTransit: this.searchVesselLastTransit,
            getTransit: this.getTransit,
            playbackTransit: this.playbackTransit,
            inspectTransit: this.inspectTransit,
            getLoadSavedData: this.getLoadSavedData,
            expandTransit: this.expandTransit,
            createSearchObject: this.createSearchObject,
        });

        await this.systemInitiation();
    }

    componentDidUpdate(prevProps: MainProps, prevState: MainState) {
        if (checkDifferent(prevState.defaultData, this.state.defaultData)) {
            console.log('EVENT Default Data changed , system will update search object ');
            this.createSearchObject(true);
        }
        if (
            checkDifferent(
                filterBySection(prevState.switchs, 'vessels'),
                filterBySection(this.state.switchs, 'vessels'),
                true
            )
        ) {
            window?.log('EVENT : Switchs changed  , transits object is updated', 'colour: orange');
            this.setTransits(this.state.transits, this.state.transitsData, getId());
        }
        if (checkDifferent(prevState.outlineInterval, this.state.outlineInterval)) {
            console.log('EVENT outlineInterval changed  , transits object is updated', 'colour: orange');
            this.props.mapControls.chart?.updateMatrixIndex('Cancel');
            this.setTransits(this.state.transits, this.state.transitsData, getId(), true);
        }
    }

    getLoadSavedData = (clear: boolean) => {
        const clonedData = clone(this.state.savedData); // safe deep clone

        if (clear) {
            this.setState({ savedData: null });
        }

        return clonedData;
    };

    loadSavedChart = async (uuid: string) => {
        const { savedData, savedDataStatus } = await this.getSavedScreensRecord(uuid);

        if (!savedDataStatus) {
            // if any errors while loading system will stop loading
            console.log('%cERROR : system failed to load saved screen', 'colour: red');
            this.props.showSystemErrorAction();
            return false;
        }

        if (
            !this.props.user.user_ports
                .map((x) => {
                    return x.port_id;
                })
                .includes(savedData.data.portId)
        ) {
            this.props.showMessageAction({
                messageType: 'ERROR',
                message: translate('your account has no access to', {
                    systemName: savedData.data.systemName,
                }),
                options: {
                    autoClose: false,
                    hideProgressBar: true,
                },
            });
            return false;
        }

        if (savedData.data.portId !== this.props.port.id) {
            this.props.showMessageAction({
                messageType: 'ERROR',
                message: translate('Unable to load saved data please change the system to', {
                    systemName: savedData.data.systemName,
                }),
                options: {
                    autoClose: false,
                    hideProgressBar: true,
                },
            });
            return false;
        }

        this.props.setLayoutAction([
            { action: 'UPDATE_SECTION', data: { name: 'chart', state: true, display: true, disable: false } },
        ]);

        this.setState(
            {
                savedData: {
                    ...savedData,
                    highlight: checkDifferent(savedData.data.searchObject, savedData.data.highlightObject),
                    data: {
                        ...savedData.data,
                        searchObject: {
                            ...formatSavedFilter(this.props.dateTimeFormat, savedData.data.searchObject),
                            uuid: uuid,
                        },
                        highlightObject: {
                            ...formatSavedFilter(this.props.dateTimeFormat, savedData.data.highlightObject),
                            uuid: uuid,
                        },
                    },
                },
            },
            () => {
                this.props.setSearchObjectAction(clone(this.state.savedData.data.searchObject));
                Object.keys(savedData.data.switchs).forEach((x) => {
                    this.props.setSwitchAction(x, { value: savedData.data.switchs[x].value });
                });
                // this.props.mapControls.chart?.setViewPort(
                //     savedData.data.map.latitude,
                //     savedData.data.map.longitude,
                //     savedData.data.map.zoom,
                //     savedData.data.map.backgrounds.find((background: BackgroundType) => {
                //         return background.status === 'active' && background.type === 'basemap';
                //     }),
                //     savedData.data.map.backgrounds.find((background: BackgroundType) => {
                //         return background.status === 'active' && background.type === 'overlay';
                //     })
                // );
            }
        );
    };

    systemInitiation = async () => {
        //@ts-ignore
        // this.props.setPortIdAction(localStorage.getItem('port_id'));

        const portManager = new PortManager();
        const port = await portManager.loadPort();
        if (!port?.id) {
            //@ts-ignore
            window.location = `${SETTINGS.BASE_URL}home`;
        }
        //@ts-ignore
        this.props.setPortAction(port);

        // BACK 2.1
        this.props.setSystemLoadingAction(true);
        // load tags
        const { tags, systemTagsStatus } = await this.getPortTags();
        //@ts-ignore

        if (!systemTagsStatus) {
            // if any errors while loading system will stop loading
            console.log('%cERROR : system failed to load port tags data', 'colour: red');
            return false;
        }
        // set tags to store
        this.props.setTagsAction(tags);

        const { defaultData, systemInfoStatus } = await this.systemInfoData(port);
        if (!systemInfoStatus) {
            // if any errors while loading system will stop loading
            console.log('%cERROR : system failed to info data', 'colour: red');

            return false;
        }
        // set defaultData to store
        this.props.setDefaultDataAction(defaultData);

        const { system, systemUpdateStatus } = await this.lastUpdateData();
        const storeSystem = JSON.parse(localStorage.getItem('system') || '{}');
        if (!systemUpdateStatus) {
            // if any errors while loading system will stop loading
            console.log('%cERROR : system failed to get last update', 'colour: red');
            this.props.showSystemErrorAction();
            return false;
        }

        if (
            system?.system.version !== storeSystem?.version ||
            system?.system.date !== storeSystem?.date ||
            system?.system.build !== storeSystem?.build
        ) {
            const { portData, getPortDataStatus } = await this.getPortData();

            if (!getPortDataStatus) {
                // if any errors while loading system will stop loading
                console.log('%cERROR : system failed to info data', 'colour: red');

                return false;
        }
 

            localStorage.removeItem('switchs');
            localStorage.removeItem('backgrounds');
            localStorage.removeItem('gridSettings');
            localStorage.setItem('system', JSON.stringify(system.system));

            await portManager.savePort(portData);
            const port = await portManager.loadPort();
            this.props.setPortAction(port);

            this.props.setSystemAction({ ...system, networkError: false }, true);
        } else {
            // set system to store
            // will work only system first run
            this.props.setSystemAction({ ...system, networkError: false }, false);
        }

        // load vessel categories
        const { vesselCategories, vesselCategoriesStatus } = await this.getSystemVesselCategories();
        if (!vesselCategoriesStatus) {
            // if any errors while loading system will stop loading
            console.log('%cERROR : system failed to load vessel categories', 'colour: red');

            return false;
        }
        // set vessel categories to store
        this.props.setVesselCategoriesAction(vesselCategories);

        if (this.props.params.uuid) {
            await this.loadSavedChart(this.props.params.uuid);
        }
        this.setState({ loading: false }, () => {
            this.props.setSystemLoadingAction(false);
            //wait until model manger start
            setTimeout(() => {
                this.checkSystemVersion(system, true);
            }, 300);
        });
    };

    getVesselLastTransit: GetVesselLastTransitInterface = (vesselName: string): Promise<TransitType[]> => {
        const searchObject: FilterObjectType = this.createSearchObject(false);
        setKey(searchObject, 'vessel.name.icontains', vesselName);
        setKey(searchObject, 'limit', 1);

        return searchData(
            'search',
            this.props.port.id,
            formatFilterObject(searchObject, this.props.port.backEnd?.version, this.props.portData)
        )
            .then(async (res) => {
                const { transits } = await formatTransits(
                    this.props.dateTimeFormat,
                    res,
                    this.props.switchs,
                    this.props.portData,
                    this.props.port.backEnd?.version || 1
                );
                return transits;
            })
            .catch((error) => {
                this.props.setErrorHandlerAction(error);
                return []; // Return an empty array or handle it based on your use case
            });
    };

    searchVesselLastTransit: SearchVesselLastTransitInterface = (vesselName: string, dateRange: string) => {
        const searchObject: FilterObjectType = this.createSearchObject(false);

        if (dateRange === 'allTimes') {
            setKey(searchObject, 'date.end_utc.op', null);
            setKey(searchObject, 'date.start_utc.op', null);
            setKey(searchObject, 'date.dateRange', '');
        } else {
            const { startDate, endDate } = this.props.dateTimeFormat
                .parseDateTime()
                .getDateFromDays(dateRange, 0, this.props.system?.date.today);
            setKey(searchObject, 'date.end_utc.op', dateRange === 'allTimes' ? null : endDate);
            setKey(searchObject, 'date.start_utc.op', dateRange === 'allTimes' ? null : startDate);
            setKey(searchObject, 'date.dateRange', dateRange);
        }

        setKey(searchObject, 'vessel.name.icontains', vesselName);
        setKey(searchObject, 'date.lastDays', '');

        this.props.setSearchObjectAction(clone(searchObject));

        setTimeout(() => {
            this.props.setLayoutAction([
                {
                    action: 'UPDATE_SECTION',
                    data: { name: 'chart', state: true, display: true, disable: false },
                },
                {
                    action: 'UPDATE_MENU',
                    data: {
                        name: 'searchMenu',
                        section: 'chart',
                        state: true,
                        active: true,
                    },
                },
                {
                    action: 'UPDATE_MENU',
                    data: {
                        name: 'searchMenu',
                        section: 'grid',
                        state: true,
                        active: true,
                    },
                },
            ]);
            this.props.searchControls.search();
        }, 1500);
    };

    private metOceanRequests: Map<string, Promise<MetOceanData[]>> = new Map();

    getMetOceanData: GetMetOceanDataInterface = (
        transit: TransitType | undefined,
        time: DateTimeFormat | null
    ): Promise<MetOceanData[]> => {
        if (!transit) {
            return Promise.resolve([]);
        }

        // build a unique key for caching (depends on transitId + time)
        const key = `${transit.id}_${time ?? 'no-time'}`;

        console.log(this.metOceanRequests);
        // if a request is already in progress for this key, return it
        if (this.metOceanRequests.has(key)) {
            return this.metOceanRequests.get(key)!;
        }

        // create the request promise
        const requestPromise = new Promise<MetOceanData[]>((resolve, reject) => {
            this.setState(
                {
                    getingMetOceanData: { transitId: transit.id, time: time, loading: true },
                },
                () => {
                    const results = getEnviroDisplayDataAvrages(
                        transit,
                        this.state.environmentalSources,
                        this.state.enviroDisplayOrder,
                        this.state.enviroDisplay,
                        this.props.port.backEnd?.version === 1
                    );

                    if (time) {
                        metOceanAtTime(this.props.port.id, this.props.port.backEnd, {
                            data: results.map((x: any) => {
                                delete x.transit;
                                return x;
                            }),
                            transitId: transit.id,
                            time: this.props.dateTimeFormat
                                .parseDateTime(time)
                                .formatUTCDateToLocal()
                                .toString(
                                    this.props.port.backEnd?.version === 2
                                        ? "yyyy-MM-dd'T'HH:mm:ss.SSS"
                                        : 'yyyy-MM-dd HH:mm:ss'
                                ),
                        })
                            .then((res) => {
                                this.setState(
                                    {
                                        metOceanData: formatMetOceanData(
                                            //@ts-ignore
                                            this.props.port.backEnd?.version === 2 ? res.sources : res.items,
                                            this.props.port.backEnd?.version || 1,
                                            results,
                                            this.state.enviroDisplay
                                        ),
                                        getingMetOceanData: {
                                            ...this.state.getingMetOceanData,
                                            loading: false,
                                        },
                                    },
                                    () => {
                                        this.metOceanRequests.delete(key); // remove after completion
                                        resolve(
                                            formatMetOceanData(
                                                //@ts-ignore
                                                this.props.port.backEnd?.version === 2 ? res.sources : res.items,
                                                this.props.port.backEnd?.version || 1,
                                                results,
                                                this.state.enviroDisplay
                                            )
                                        );
                                    }
                                );
                            })
                            .catch((errors) => {
                                if (errors.code !== 'ERR_CANCELED') {
                                    this.props.showMessageAction({
                                        messageType: 'WARN',
                                        message: translate('No MetOcean data avalable.'),
                                        options: {
                                            autoClose: true,
                                            hideProgressBar: false,
                                        },
                                    });
                                }
                                this.setState(
                                    {
                                        getingMetOceanData: {
                                            ...this.state.getingMetOceanData,
                                            loading: false,
                                        },
                                    },
                                    () => {
                                        this.metOceanRequests.delete(key); // remove on error too
                                        reject(errors);
                                    }
                                );
                            });
                    } else {
                        this.setState(
                            {
                                getingMetOceanData: {
                                    ...this.state.getingMetOceanData,
                                    loading: false,
                                },
                            },
                            () => {
                                this.metOceanRequests.delete(key);
                                resolve(results);
                            }
                        );
                    }
                }
            );
        });

        // store the in-flight request
        this.metOceanRequests.set(key, requestPromise);

        return requestPromise;
    };

    render() {
        return (
            <>
                <ApplicationError></ApplicationError>
                <ServerError></ServerError>
                <ApplicationLoading></ApplicationLoading>
                <ForbiddenError></ForbiddenError>
                <NetworkError></NetworkError>
                <MobileError></MobileError>

                {/* only load the app if the load is completed  */}
                {!this.state.loading && (
                    <>
                        {/* modals */}
                        <ModalManager></ModalManager>
                        <KeyboardManager></KeyboardManager>
                        <MenuManager></MenuManager>
                        {/* header */}
                        <Tabs></Tabs>
                        <Toolbar></Toolbar>
                        <User></User>

                        {/* body */}

                        <Chart active={this.state.layout.sections?.chart.state}></Chart>
                        <Grid transits={this.state.transits} active={this.state.layout.sections.grid.state}></Grid>
                        <Profile active={this.state.layout.sections.profile.state}></Profile>
                        {!!this.state.layout.sections?.aiChat.display && !!this.state.layout.sections?.aiChat.time && (
                            <Chat active={this.state.layout.sections.aiChat.state} />
                        )}


                        <MetOcean active={this.state.layout.sections?.metOceanChart.state}></MetOcean>

                        {this.state.layout.sections?.tagsManager.state && (
                            <Tags active={this.state.layout.sections?.tagsManager.state}></Tags>
                        )}
                        {this.state.layout.sections?.portsManager.state && (
                            <Ports active={this.state.layout.sections?.portsManager.state}></Ports>
                        )}
                        {this.state.layout.sections?.searchesManager.state && (
                            <Searches active={this.state.layout.sections?.searchesManager.state}></Searches>
                        )}
                        {this.state.layout.sections?.commentsManager.state && (
                            <Comments active={this.state.layout.sections?.commentsManager.state}></Comments>
                        )}
                        {this.state.layout.sections?.usersManager.state && (
                            <Users active={this.state.layout.sections?.usersManager.state}></Users>
                        )}
                        {/* BACK 2.1 {(this.state.layout.sections?.playback.state || this.state.layout.playbackId) && (
                            <Playback active={this.state.layout.sections?.playback.state}></Playback>
                        )} */}
                        {(this.state.layout.sections?.playback.state ||
                            this.state.layout.sections.playback.data?.transit?.id) && (
                            <Playback active={this.state.layout.sections?.playback.state}></Playback>
                        )}
                        {/* BACK 2.1 {(this.state.layout.sections?.time.state ||
                            this.state.layout.sections?.time.data.startTime) && (
                            <Time active={this.state.layout.sections?.time.state}></Time>
                        )} */}
                        {(this.state.layout.sections?.time.state ||
                            this.state.layout.sections.time.data.startTime ||
                            this.props.layout.viewMode === 'live') && (
                            <Time active={this.state.layout.sections?.time.state}></Time>
                        )}
                    </>
                )}
            </>
        );
    }
}

const mainStateToProps = (state: RootState) => ({
    layout: state.layout.layout,

    outlineInterval: state.map.outlineInterval,
    port: state.port.port,
    portData: state.port,
    user: state.user.user,
    system: state.port.system,
    searchObject: state.layout.searchObject,
    switchs: state.layout.switchs,
    defaultData: state.port.defaultData,
    mapControls: state.map.mapControls,
    searchControls: state.layout.searchControls,
    mode: state.layout.mode,
    dateTimeFormat: state.port.dateTimeFormat,
    openModelFunction: state.layout.openModelFunction,
    closeModelFunction: state.layout.closeModelFunction,
});

// eslint-disable-next-line @typescript-eslint/no-explicit-any
const mainDispatchToProps = (dispatch: Dispatch) => ({
    setPortAction: bindActionCreators(setPortAction, dispatch),
    setSystemAction: bindActionCreators(setSystemAction, dispatch),
    setMainControlsAction: bindActionCreators(setMainControlsAction, dispatch),
    setSearchObjectAction: bindActionCreators(setSearchObjectAction, dispatch),
    setSwitchAction: bindActionCreators(setSwitchAction, dispatch),
    setHighlightObjectAction: bindActionCreators(setHighlightObjectAction, dispatch),
    setDefaultDataAction: bindActionCreators(setDefaultDataAction, dispatch),
    setTagsAction: bindActionCreators(setTagsAction, dispatch),
    setVesselCategoriesAction: bindActionCreators(setVesselCategoriesAction, dispatch),
    setLayoutAction: bindActionCreators(setLayoutAction, dispatch),
    setOpendMenuAction: bindActionCreators(setOpendMenuAction, dispatch),
    showSystemErrorAction: bindActionCreators(showSystemErrorAction, dispatch),
    setSystemLoadingAction: bindActionCreators(setSystemLoadingAction, dispatch),
    setPortIdAction: bindActionCreators(setPortIdAction, dispatch),
    setErrorHandlerAction: bindActionCreators(setErrorHandlerAction, dispatch),
    showMessageAction: bindActionCreators(showMessageAction, dispatch),
});

export default connect(mainStateToProps, mainDispatchToProps)(withRouter(Main));
